import { FC } from 'react';

interface Props {
  className?: string;
}

export const ChevronDownIcon: FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.03328 9.58579L13.0741 4.29289C13.4461 3.90237 14.0491 3.90237 14.421 4.29289C14.7929 4.68342 14.7929 5.31658 14.421 5.70711L8.70672 11.7071C8.33479 12.0976 7.73178 12.0976 7.35985 11.7071L1.64556 5.70711C1.27364 5.31658 1.27364 4.68342 1.64556 4.29289C2.01749 3.90237 2.62051 3.90237 2.99243 4.29289L8.03328 9.58579Z"
      fill="currentColor"
    />
  </svg>
);
